/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ProposedActionItem } from "./ProposedActionItem";
import {
  ProposedActionItemFromJSON,
  ProposedActionItemFromJSONTyped,
  ProposedActionItemToJSON,
  ProposedActionItemToJSONTyped,
} from "./ProposedActionItem";
import type { MeetingParticipant } from "./MeetingParticipant";
import {
  MeetingParticipantFromJSON,
  MeetingParticipantFromJSONTyped,
  MeetingParticipantToJSON,
  MeetingParticipantToJSONTyped,
} from "./MeetingParticipant";

/**
 *
 * @export
 * @interface CompanyMeetingPreview
 */
export interface CompanyMeetingPreview {
  /**
   *
   * @type {string}
   * @memberof CompanyMeetingPreview
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeetingPreview
   */
  jamieMeetingId: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeetingPreview
   */
  jamieUrl: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeetingPreview
   */
  title?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyMeetingPreview
   */
  meetingDate?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof CompanyMeetingPreview
   */
  summaryShort?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyMeetingPreview
   */
  summaryMarkdown?: string | null;
  /**
   *
   * @type {Array<MeetingParticipant>}
   * @memberof CompanyMeetingPreview
   */
  participants: Array<MeetingParticipant>;
  /**
   *
   * @type {Array<ProposedActionItem>}
   * @memberof CompanyMeetingPreview
   */
  proposedActionItems: Array<ProposedActionItem>;
}

/**
 * Check if a given object implements the CompanyMeetingPreview interface.
 */
export function instanceOfCompanyMeetingPreview(
  value: object,
): value is CompanyMeetingPreview {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  if (!("jamieUrl" in value) || value["jamieUrl"] === undefined) return false;
  if (!("participants" in value) || value["participants"] === undefined)
    return false;
  if (
    !("proposedActionItems" in value) ||
    value["proposedActionItems"] === undefined
  )
    return false;
  return true;
}

export function CompanyMeetingPreviewFromJSON(
  json: any,
): CompanyMeetingPreview {
  return CompanyMeetingPreviewFromJSONTyped(json, false);
}

export function CompanyMeetingPreviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyMeetingPreview {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    jamieMeetingId: json["jamieMeetingId"],
    jamieUrl: json["jamieUrl"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
    summaryShort:
      json["summaryShort"] == null ? undefined : json["summaryShort"],
    summaryMarkdown:
      json["summaryMarkdown"] == null ? undefined : json["summaryMarkdown"],
    participants: (json["participants"] as Array<any>).map(
      MeetingParticipantFromJSON,
    ),
    proposedActionItems: (json["proposedActionItems"] as Array<any>).map(
      ProposedActionItemFromJSON,
    ),
  };
}

export function CompanyMeetingPreviewToJSON(json: any): CompanyMeetingPreview {
  return CompanyMeetingPreviewToJSONTyped(json, false);
}

export function CompanyMeetingPreviewToJSONTyped(
  value?: CompanyMeetingPreview | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    jamieMeetingId: value["jamieMeetingId"],
    jamieUrl: value["jamieUrl"],
    title: value["title"],
    meetingDate: value["meetingDate"],
    summaryShort: value["summaryShort"],
    summaryMarkdown: value["summaryMarkdown"],
    participants: (value["participants"] as Array<any>).map(
      MeetingParticipantToJSON,
    ),
    proposedActionItems: (value["proposedActionItems"] as Array<any>).map(
      ProposedActionItemToJSON,
    ),
  };
}
